import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import { EMPTY_POINT } from './helpers'

const state = {
    form: {
        point: { ...EMPTY_POINT },
        action: null, // null value to hide form, 'create' or 'update' values to show form
        index: null // index of the point to update
    },
    focusedPoint: {
        index: null,
        shouldFly: true,
        shouldFlyEvenIfInMap: false,
        shouldScroll: true
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
